import { render, staticRenderFns } from "./SidebarTopic.vue?vue&type=template&id=619fa2d0&"
import script from "./SidebarTopic.vue?vue&type=script&lang=js&"
export * from "./SidebarTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports